import { useState, useEffect } from 'react';

export const useIsNativeApp = () => {

  const [isNativeApp, setIsNativeApp] = useState(false);

  useEffect(() => {
    // 1. Check User Agent (We will tell Flutter to inject 'Mobile-App')
    const userAgent = window.navigator.userAgent || "";
    const hasAppUserAgent = userAgent.includes('Mobile-App');

    // 2. Check URL Parameter (Safety fallback: /?app=true)
    const urlParams = new URLSearchParams(window.location.search);
    const hasAppQuery = urlParams.get('app') === 'true';

    if (hasAppUserAgent || hasAppQuery) {
      setIsNativeApp(true);
      // Adds a class to the body to block zooming and copying text
      document.body.classList.add('native-app-mode');
    }
  }, []);

  return isNativeApp;
};
